import { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = useCallback((product, quantity = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i.id === product.id);
      if (existing) {
        return prev.map(i => i.id === product.id ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, { ...product, quantity }];
    });
    setIsOpen(true);
  }, []);

  const removeItem = useCallback((productId) => {
    setItems(prev => prev.filter(i => i.id !== productId));
  }, []);

  const updateQuantity = useCallback((productId, quantity) => {
    if (quantity <= 0) {
      setItems(prev => prev.filter(i => i.id !== productId));
      return;
    }
    setItems(prev => prev.map(i => i.id === productId ? { ...i, quantity } : i));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);
  const totalPrice = items.reduce((sum, i) => sum + (i.price * i.quantity), 0);

  const addDuo = useCallback((tier) => {
    const duoProducts = tier === 'daily'
      ? [
          { id: 'daily-face-wash', name: 'TRUFORM Daily Face Wash', price: 249, size: '100ml', image: 'https://static.prod-images.emergentagent.com/jobs/5d269af6-e239-4577-baf0-94dde8e2fa47/images/0cb90e7de57c9368048be6399ba5c360af631a4732d2cc2a029a633e4cd29e0f.png' },
          { id: 'daily-moisturiser-spf30', name: 'TRUFORM Daily Moisturiser SPF 30', price: 299, size: '50ml', image: 'https://static.prod-images.emergentagent.com/jobs/5d269af6-e239-4577-baf0-94dde8e2fa47/images/0cb90e7de57c9368048be6399ba5c360af631a4732d2cc2a029a633e4cd29e0f.png' }
        ]
      : [
          { id: 'pro-active-face-wash', name: 'TRUFORM Pro Active Face Wash', price: 449, size: '100ml', image: 'https://static.prod-images.emergentagent.com/jobs/5d269af6-e239-4577-baf0-94dde8e2fa47/images/8a74635f821a3e034a86e6ea5605b0d57aa7f45d390edb0c415674c3aec22dfc.png' },
          { id: 'pro-defence-moisturiser-spf50', name: 'TRUFORM Pro Defence Moisturiser SPF 50', price: 549, size: '50ml', image: 'https://static.prod-images.emergentagent.com/jobs/5d269af6-e239-4577-baf0-94dde8e2fa47/images/8a74635f821a3e034a86e6ea5605b0d57aa7f45d390edb0c415674c3aec22dfc.png' }
        ];

    setItems(prev => {
      let updated = [...prev];
      duoProducts.forEach(product => {
        const existing = updated.find(i => i.id === product.id);
        if (existing) {
          updated = updated.map(i => i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i);
        } else {
          updated.push({ ...product, quantity: 1 });
        }
      });
      return updated;
    });
    setIsOpen(true);
  }, []);

  return (
    <CartContext.Provider value={{ items, isOpen, setIsOpen, addItem, removeItem, updateQuantity, clearCart, totalItems, totalPrice, addDuo }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
}
